import {
  Badge,
  TooltipRenderer,
  Text,
  IconSecurity,
} from 'braid-design-system';

/**
 * Badge indicating that a documented option is recommended over other options.
 */
export const Recommended = () => (
  <Badge tone="promote" weight="strong">
    Recommended
  </Badge>
);

/**
 * Badge indicating that something is important.
 */
export const Important = () => (
  <Badge tone="critical" weight="strong">
    Important
  </Badge>
);

/**
 * Badge indicating that something is limited release.
 */
export const Limited = ({ compact = false }: { compact?: boolean }) => (
  <TooltipRenderer
    id="limited-availability-tooltip"
    placement="top"
    tooltip={
      <Text>This feature is available to a limited number of partners</Text>
    }
  >
    {({ triggerProps }) =>
      compact ? (
        <span {...triggerProps} style={{ marginTop: '-1px' }}>
          <IconSecurity />
        </span>
      ) : (
        <Badge tone="neutral" {...triggerProps}>
          {compact ? 'Limited' : 'Limited availability'}
        </Badge>
      )
    }
  </TooltipRenderer>
);
